/**------------- Link constants -------------**/

/*  General  */
export const LINK_CLASS_NAME = "link";
